export default __webpack_public_path__ + "static/media/wield.7114c8c7.jpg";